var _rect, _circle, _circle2, _circle3, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIac(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 81,
    fill: "none",
    viewBox: "0 0 81 81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    x: 0.667,
    y: 0.855,
    fill: "#fff",
    fillOpacity: 0.08,
    rx: 40
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51.146,
    cy: 54.148,
    r: 4.452,
    fill: "#5B9300"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.319,
    cy: 54.148,
    r: 4.452,
    fill: "#5B9300"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.319,
    cy: 27.485,
    r: 4.452,
    fill: "#5B9300"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M52.987 49.508V26.566a.716.716 0 0 0-.714-.714h-7.59V22.78a.324.324 0 0 0-.522-.254l-5.696 4.5a.32.32 0 0 0 0 .504l5.691 4.5c.21.165.523.018.523-.254v-3.067h5.09v20.799a5.01 5.01 0 0 0-3.394 4.736c0 2.76 2.241 5 5 5a5.003 5.003 0 0 0 1.612-9.736m-1.607 6.88a2.143 2.143 0 0 1 0-4.286 2.143 2.143 0 0 1 0 4.285m-16.43-28.93c0-2.758-2.24-5-5-5s-5 2.242-5 5a5.01 5.01 0 0 0 3.393 4.737v17.317a5.005 5.005 0 0 0-3.393 4.737c0 2.759 2.241 5 5 5s5-2.241 5-5a5.01 5.01 0 0 0-3.393-4.737V32.195a5.01 5.01 0 0 0 3.393-4.736m-7.143 0a2.144 2.144 0 0 1 4.286 0 2.143 2.143 0 0 1-4.286 0m4.286 26.786a2.143 2.143 0 0 1-4.286 0 2.144 2.144 0 0 1 4.286 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIac);
export default __webpack_public_path__ + "static/media/iac.ac24edd342b632272bfdfc3ff85a3187.svg";
export { ForwardRef as ReactComponent };